// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"313":"3a29f13b","668":"34a087d0","787":"8f54a547"}[chunkId] + ".chunk.js";
};